// extracted by css-extract-rspack-plugin
export default {"rating":"gBNQp","average_rating":"SsCLC","averageRating":"SsCLC","rating_text":"EgQTX","ratingText":"EgQTX","votes":"Ya04n"};